export default {"src":"/_next/static/media/lifebuoy_24.49ffc2ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};